import { coreInitiativesByIdGetAsyncSlice } from './get';
import { CoreInitiativesByIdName } from './name';
import { InitiativeStatusReference } from '@types';
import { patchInitiativeById } from '@api';

import { AMPLITUDE_EVENT, amplitudeActions } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, ResultsCollection, SagaYieldType } from '@sonar-software/xuder';
import { put, select } from 'redux-saga/effects';

export const coreInitiativesByIdPatchAsyncSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: function* (action) {
				const { assignedTo, initiativeStatusId } = action.data.patchInitiativeDescription;

				if (Number.isInteger(assignedTo)) {
					yield put(
						amplitudeActions.requestAmplitudeEvent({
							id: AMPLITUDE_EVENT.OWNER_ASSIGNED
						})
					);
				}

				if (Number.isInteger(initiativeStatusId)) {
					const oldStatusId: number = yield select(
						(state) => state.core.initiatives.byId.get.data.initiativeStatusId
					);
					const statuses: ResultsCollection<InitiativeStatusReference> | undefined = yield select(
						(state) => state.core.initiatives.statuses.get.data
					);

					const oldStatusName = statuses?.results.find((status) => status.id === oldStatusId)?.name;
					const newStatusName = statuses?.results.find((status) => status.id === initiativeStatusId)?.name;

					yield put(
						amplitudeActions.requestAmplitudeEvent({
							data: {
								from: oldStatusName,
								to: newStatusName
							},
							id: AMPLITUDE_EVENT.STATUS_CHANGED
						})
					);
				}
			},
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				coreInitiativesByIdGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiativesById((previous) => ({
					...previous,
					id: request.initiativeId
				}))
		]
	},
	name: CoreInitiativesByIdName,
	receive: false,
	request: true,
	requestHandler: patchInitiativeById,
	yieldType: SagaYieldType.Latest
});
